import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { OAuthService } from 'angular-oauth2-oidc';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService  {

constructor(
  private oauthService: OAuthService,
  @Inject(PLATFORM_ID) private platformId: Object
) { }

canActivate(
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean|UrlTree>|Promise<boolean|UrlTree>|boolean|UrlTree {

  const promise = new Promise<boolean>( (resolve, reject) => {  
// $&("AuthGuardService",window.location.host )
    if (!isPlatformBrowser(this.platformId)) {
      return resolve(true);
    }
    
    // Safe to use window now since we're in browser
    if (window.location.host =="localhost:4200" || window.location.host =="localhost:4001" ||  (environment.production && (window.location.host == "investingforcatholics.com" || window.location.host == "www.investingforcatholics.com"))) {
      return resolve(true);
    }
    
    return this.oauthService.tryLoginImplicitFlow().then(resp => {

    var valid = this.oauthService.hasValidAccessToken()

    if (!valid) {
      sessionStorage.setItem('return_url', state.url)
      this.oauthService.initLoginFlow();
      resolve(false)
    } else {
      resolve(true);

    }
// $&(promise)
// $&(valid)
  })

}
  )

  return promise

}

}
